"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MenuItem = function MenuItem(props) {
  var isActive = props.isActive,
      classNames = props.classNames,
      id = props.id,
      onClick = props.onClick,
      disabled = props.disabled,
      value = props.value,
      extraProps = _objectWithoutProperties(props, ["isActive", "classNames", "id", "onClick", "disabled", "value"]); // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var menuItemClassNames = {
    'menu-item': true,
    'menu-item--active': isActive,
    'menu-item--disabled': disabled
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(menuItemClassNames, classNames),
    role: "button",
    tabIndex: 0,
    onClick: onClick && function (e) {
      if (!disabled) onClick(e, value);
    },
    id: id,
    onKeyDown: _handleKeyPress
  }, extraProps), /*#__PURE__*/_react.default.createElement("span", null, props.label));
};

MenuItem.propTypes = {
  classNames: _propTypes.default.any,
  onClick: _propTypes.default.func,
  isActive: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  value: _propTypes.default.string
};
var defaultProps = {
  classNames: '',
  disabled: false,
  onClick: function onClick() {},
  isActive: false
};
MenuItem.defaultProps = defaultProps;
var _default = MenuItem;
exports.default = _default;